var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll:[scrollTarget]",value:(_vm.onScroll),expression:"onScroll",arg:_vm.scrollTarget}],attrs:{"id":"scroll-fetch-more"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }